<template>
    <vs-button type="border" icon-pack="feather" size="small" icon="icon-plus" @click="$emit('addGoal')"></vs-button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Add New Goal'
    },
  },
}
</script>
